const TailoringSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="order-1">
            <h2 className="text-4xl font-bold text-accent mb-6">خدمة التفصيل</h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              نوفر لكم خدمة تفصيل الثياب بأعلى مستويات الدقة والاحترافية. فريقنا من الخياطين المهرة يضمن لكم الحصول على ثوب مثالي يناسب مقاساتكم بالضبط ويعكس ذوقكم الرفيع.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white p-6 rounded-2xl shadow-sm">
                <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-scissors-line text-2xl text-secondary"></i>
                </div>
                <h3 className="text-xl font-bold text-accent mb-2">تفصيل احترافي</h3>
                <p className="text-gray-600">خياطون ذوو خبرة عالية</p>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-sm">
                <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-ruler-line text-2xl text-secondary"></i>
                </div>
                <h3 className="text-xl font-bold text-accent mb-2">مقاسات دقيقة</h3>
                <p className="text-gray-600">ضمان المقاس المثالي</p>
              </div>
            </div>

            <a
              href="/tailoring"
              className="inline-block bg-secondary text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-opacity-90 transition-all cursor-pointer whitespace-nowrap"
            >
              انتقل إلى صفحة التفصيل
            </a>
          </div>

          {/* Image */}
          <div className="order-2">
            <div className="bg-white rounded-3xl p-12 flex items-center justify-center shadow-sm">
              <img
                src="https://public.readdy.ai/ai/img_res/a406835e42ccc580a13c9d73f534be05.jpg"
                alt="خدمة التفصيل"
                className="w-full max-w-md h-auto object-contain rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TailoringSection;
